export const product = {
  // Hero
  heroTitle: 'ألياف الصلب ذات النهاية المعقوفة',
  heroSubtitle: 'حل تعزيز خرسانة مميز مصمم للأداء المتفوق والمتانة',

  // Overview
  overviewTitle: 'نظرة عامة على المنتج',
  overviewDesc: 'ألياف الصلب DYNAMIX ذات النهاية المعقوفة هي حلول تعزيز خرسانة عالية الأداء مصنعة من سلك صلب مميز مبرد. تتميز أليافنا بهندسة نهاية معقوفة محسّنة توفر تثبيتاً استثنائياً في مصفوفة الخرسانة، مما يضمن نقل حمولة متفوق وتحكم في التشققات.',

  downloadDatasheet: 'تحميل ورقة البيانات التقنية',
  requestQuote: 'طلب عرض أسعار',

  // Technical Specs
  specsTitle: 'المواصفات التقنية',
  specsSubtitle: 'مصممة بدقة لتلبية أكثر متطلبات البناء صرامة.',

  specMaterial: 'المادة',
  specMaterialValue: 'سلك صلب مبرد',

  specTensile: 'قوة الشد',
  specTensileValue: '1000-1200 ميجا باسكال',
  specTensileBig: '>1100 ميجا باسكال',

  specLength: 'الطول',
  specLengthValue: '30-60 ملم (قابل للتخصيص)',
  specLengthBig: '30-60 ملم',

  specDiameter: 'القطر',
  specDiameterValue: '0.5-1.0 ملم',
  specDiameterBig: '0.5-1.0 ملم',

  specAspect: 'نسبة العرض إلى الطول',
  specAspectValue: '45-80',
  specAspectBig: '45-80',

  specDosage: 'الجرعة النموذجية',
  specDosageValue: '20-40 كجم/م³',

  specStandard: 'الامتثال للمعايير',
  specStandardValue: 'ASTM A820, TS EN 14889-1',
  specStandardBig: 'ASTM A820',

  specPackaging: 'التعبئة',
  specPackagingValue: 'أكياس 20 كجم، أكياس كبيرة 1000 كجم',

  // Key Advantages
  advantagesTitle: 'المزايا الرئيسية',
  advantagesSubtitle: 'اكتشف لماذا تختار شركات البناء الرائدة ألياف Dynamix الفولاذية.',

  adv1Title: 'أداء هيكلي محسّن',
  adv1Desc: 'يحسّن بشكل كبير قوة الشد بعد التشقق وقدرة تحمل الأحمال للخرسانة.',

  adv2Title: 'تحكم متفوق في التشققات',
  adv2Desc: 'شبكة الألياف ثلاثية الأبعاد تتحكم بفعالية في تشقق الخرسانة البلاستيكية والمتصلبة.',

  adv3Title: 'متانة متزايدة',
  adv3Desc: 'يمدد عمر خدمة هياكل الخرسانة من خلال تحسين المقاومة للصدمات والتعب والعوامل البيئية.',

  adv4Title: 'تقليل وقت البناء',
  adv4Desc: 'يلغي تركيب الشبكة المستهلك للوقت، مما يسرع إتمام المشروع.',

  adv5Title: 'توفير التكاليف',
  adv5Desc: 'تكاليف عمالة أقل ونفايات مواد مخفضة مقارنة بطرق التعزيز التقليدية.',

  adv6Title: 'تطبيق متعدد الاستخدامات',
  adv6Desc: 'مناسب لتطبيقات خرسانية متنوعة من الأرضيات الصناعية إلى بطانة الأنفاق.',
};

